import React, { useEffect, useRef, useState } from "react";
import { Loader, Stack } from "@mantine/core";
import { useServerApi } from "../../hooks/userServerApi";
import { normalizeExtraFieldValuesFromApi } from "../../helpers/extraFieldValues";
import ExtraFieldsInput from "./ExtraFieldsInput";

const ExtraFieldsSection = ({
  form,
  entityType,
  columns = 1,
  disabled = false,
  formMode,
  onChange,
}) => {
  const [api] = useServerApi();
  const apiRef = useRef(api);
  apiRef.current = api;
  const [definitions, setDefinitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const readOnly = formMode === "show" || disabled || Boolean(form?.isReadOnly?.());

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const result = await apiRef.current.search({
          apiEntity: "extraField",
          pageSize: 200,
          currentPage: 1,
          sort: { by: "sortOrder", order: "asc" },
          searchQuery: {
            entityType,
            showInEditForm: true,
            active: true,
          },
          byAggregation: false,
        });
        if (mounted) setDefinitions(result?.docs ?? []);
      } catch (error) {
        console.log(error);
        if (mounted) setDefinitions([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [entityType]);

  if (loading) {
    return (
      <Stack align="center" py="md">
        <Loader size="sm" />
      </Stack>
    );
  }

  if (!definitions.length) return null;

  const rawValues = form?.values?.extraFieldValues ?? {};
  const values = normalizeExtraFieldValuesFromApi(rawValues);

  const handleChange = (next) => {
    form?.setFieldValue("extraFieldValues", next);
    // Mark the form dirty. The argument is intentionally empty: Mantine's
    // input onChange treats a missing value as a clear, so the form renderer
    // must not forward this call for the extraFieldValues field.
    onChange?.();
  };

  return (
    <ExtraFieldsInput
      definitions={definitions}
      values={values}
      form={form}
      columns={columns}
      readOnly={readOnly}
      disabled={readOnly}
      onChange={handleChange}
    />
  );
};

ExtraFieldsSection.displayName = "ExtraFieldsSection";

export default ExtraFieldsSection;
